<template>
  <div>
    <div class="modal-body">
      <p>O e-mail com as instruções para redefinir a senha foi enviado!</p>
      <div class="email-delivered__wrapper">
        <label>EMAIL ENVIADO PARA</label>
        <p ref="student-email">
          {{ email }}
        </p>

        <label>LINK COM AS INSTRUÇÕES</label>
        <div class="email-delivered__info">
          <a ref="reset-url" target="blank" :href="resetUrl">{{ resetUrl }}</a>
          <i
            :title="clipboardTitle"
            @click="copyToClipboard"
            class="fa-2x far fa-copy email-delivered__icon"
          >
          </i>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" @click="onClose">
        Finalizar
      </button>
    </div>
  </div>
</template>

<script>

export default {
  data: () => ({
    clipboardTitle: 'Clique aqui para copiar',
  }),
  props: {
    resetUrl: {
      type: String,
      required: true,
      default: '',
    },
    email: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.resetUrl);
      this.clipboardTitle = 'Copiado!';
    },
  },
};
</script>
<style scoped lang="scss">
@import 'assets/stylesheets/utils/_spacing.sass';
@import 'assets/stylesheets/utils/_colors.sass';

.email-delivered__wrapper {
  background-color: $lightest-gray;
  padding: $space-m;
}

.email-delivered__info {
  display: flex;
  justify-content: space-between;
}
.email-delivered__icon {
  cursor: pointer;
}
</style>
